import axios from "axios";
import { SETTINGS } from "../../Settings";

export const VerificationRepository = {
  verify: (appEntry) => {
    return axios({
      url: `${SETTINGS.EXTERNAL_API_URL}external/verification/${appEntry}`,
      method: "POST",
    });
  },
};
